import type { ReactElement } from 'react';
import Head from 'next/head';
import type { GlobalHeaderProps } from '@eventbrite/consumer-header.global-header';
import { Header } from '@/src/listings/components/Header';
import { Footer } from '@/src/listings/components/Footer';
import { AssetsPrefetchLinks, FavIconLinks, MetaTags } from '@eventbrite/webapp-public-content';
import { BaseProps } from '@/src/listings/types';

export interface ErrorPageProps extends BaseProps {
  title: string;
  description: string;
  children: React.ReactNode;
  globalHeaderProps?: GlobalHeaderProps;
}

export function ErrorPage({ title, description, children, stage, globalHeaderProps }: ErrorPageProps): ReactElement {
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="robots" content="noindex, nofollow" />
        <AssetsPrefetchLinks />
        <FavIconLinks stage={stage} />
      </Head>
      <MetaTags showDefaultDescription={false} />
      <Header globalHeaderProps={globalHeaderProps} />
      {children}
      <Footer />
    </>
  );
}
